/**
 * EvolunicLogo.js — The Evolunic connected-nodes logo as a React SVG component.
 * Matches the logo on evolunic.com — network of connected circles.
 */
import React from 'react';

const EvolunicLogo = ({ size = 22, color = 'white', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="1.5"
    strokeLinecap="round"
    {...props}
  >
    <circle cx="4" cy="6" r="2" fill={color} stroke="none" />
    <circle cx="4" cy="12" r="2" fill={color} stroke="none" />
    <circle cx="4" cy="18" r="2" fill={color} stroke="none" />
    <circle cx="12" cy="8" r="2" fill={color} stroke="none" />
    <circle cx="12" cy="16" r="2" fill={color} stroke="none" />
    <circle cx="20" cy="12" r="2" fill={color} stroke="none" />
    <path d="M6 6l4 2M6 12h4M6 18l4-2M14 8l4 4M14 16l4-4" stroke={color} />
  </svg>
);

export default EvolunicLogo;
